import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
	AdminSidebar,
	CreateGroupOwner,
	CreateEmployee,
	CreateDependent,
	SignUp,
	Login,
	ForgotUsername,
	GeneratePasswordLink,
	ResetPasswordLink,
	MyProfile,
	Employees,
	DashBoard,
	AddLocation,
	MoveEmployee,
	Locations,
	EditLocation,
	GroupMembers,
	AssignGroups,
	EditAnnouncement,
	Announcements,
	AnnouncementAssignGroups,
	HealthLinksAssignGroups,
	PortalCustomization,
	HealthLinks,
	EditHealthLink,
	UserManagement,
	UserInformation,
	EmployerSidebar,
	PlanManagement,
	KsopForm,
	OpenEnrollment,
	AllEnrollments,
	GroupHome,
	GroupManagement,
	Members,
	EOBDetails,
	EmployerDashboard,
	MemberDetails,
	AddEmployment,
	AddPaycheck,
	EditContactInformation,
	EditProfileInformation,
	DependentDetails,
	EditDependentProfileInformation,
	EditDependentContactInformation,
	VEBOpenEnrollment,
	AllVEBEnrollments,
	HealthPlanForm,
	DynamicHealthPlanForm,
	ClinicCardForm,
	LincolnForm,
	EditUserProfileInformation,
	ReportManagement,
	CensusReport,
	LocationEmployeeReport,
	DependentReport,
	TotalDeductionReport,
	PlanDeductionReport,
	BenefitChangesReport,
	PersonalChangeReport,
	EmployeeTerminationReport,
	VEBDeductionReport,
	BulkUpload,
	// HealthLinksAssignGroups,
	// EditLocation,
	// UserInformation,
	// GLIForm,
	GLIFormV2,
	EmployeeInfoChangesReport,
	ChristmasClubForm,
	EnrollerManagementGrid,
	EnrollerReportManagement,
	EnrollerReport,
	AgentReport,
	CheckDate, // check date for testing,
	OpenEnrollmentChangesReport,
	LoginV2,
	ForgotUsernameV2,
	GeneratePasswordLinkV2,
	ResetPasswordV2,
	EmptyBenefitAmountReport,
	EmptyRiderBenefitAmountReport,
	InvalidSubPlanReport,
	InvalidMemberSSNFromVEBEnrollmentReport,
	SignUpV2,
	Summary,
	InvalidStateForMemberReport,
	InvalidZIPForMemberReport,
	NotExistMemberLocationReport,
	ActiveGroupPlanNullEffectiveDateReport,
	VEBWaivedBenefitsReport,
	ActivePaycheckLessThanOneReport,
	ActivePlanForEmployeeReport,
	RemittanceReport,
	ActivePaycheckReport,
	DependentMoreThanEqualTo26Report,
	MemberInfoUpdate,
	EmailUpdation,
	SSNUpdation,
	LocationNumberUpdation,
	BuyUpEligibilityUpdation,
	HireDateUpdate,
	DateOfBirthUpdate,
	ActiveHealthPlanAndClinicCardMemberReport,
	VEBBillingReport,
	IntercityHealthPlanForm,
	IntercityHealthPlanFormV2,
	MemberChangePassword,
	EditMemberSettings,
	MemberSettings,
	IntercityGroupLongTermDisabilityForm,
	EditDependentSettings,
	Providers,
	AddProviders,
	AddProvidersBulk,
	UpdateProvidersByTaxId,
	EditProviders,
	DocumentSharing,
	CoreAgentReport,
	CoreEnrollerReport,
	CoreActiveEnrollmentsForYOEReport,
	VEBActiveEnrollmentsForYOEReport,
	ProvidersInformation,
	CreateCorePlan,
	GroupForm,
	ApprovalPlanForm
} from "./components/pages";
import ExcelToJson from "./components/pages/employer/plan/createPlan/veb/ExcelToJson";
import CreateVEBPlanV1 from "./components/pages/employer/plan/createPlan/veb/CreateVEBPlanV1";
import { AuthContext, AuthContextProvider, GroupContextProvider, UIContextProvider } from "./contexts";
import "./App.css";
import "./globalStyles/memberPortalTheme.css";
import "./globalStyles/VEBTheme.css";
import "./globalStyles/theme.css";
import AlertSubscriptionManagement from "./components/pages/settings/alertSubscriptionManagement/AlertSubscriptionManagement";
import EmployeePageDesign from "./components/pages/settings/employeePageDesign/EmployeePageDesign";
import HealthCardConfig from "./components/pages/settings/healthCardConfig/HealthCardConfig";
import AssetLibrary from "./components/pages/settings/healthCardConfig/AssetLibrary";
import { AllNotifications, AutoLogout } from "./components/shared";
import PDForm from "./components/pages/employer/members/memberDetails/enrollments/plans/pd/PDForm";
import EOB from "./components/pages/employer/members/memberDetails/claim/EOB/EOB";
import GstdForm from "./components/pages/employer/members/memberDetails/enrollments/plans/GSTD/GstdForm";
import GltdForm from "./components/pages/employer/members/memberDetails/enrollments/plans/GLTDClass1/GltdForm";
import { Helmet } from "react-helmet";
import WLTCompareReport from "./components/pages/reportManagement/generalReports/wltCompareReport/WLTCompareReport";
import VEBTermination from "./components/pages/employer/members/bulkUpload/VEBTermination";
import BulkText from "./components/pages/admin/bulkText/BulkText";
import VebDataExport from "./components/pages/admin/vebDataExport/VebDataExport";
import CorePreviouslyActiveCurrentlyWaivedForYOEReport from "./components/pages/reportManagement/generalReports/previouslyActiveCurrentlyWaived/CorePreviouslyActiveCurrentlyWaivedForYOEReport";
import VEBPreviouslyActiveCurrentlyWaivedForYOEReport from "./components/pages/reportManagement/generalReports/previouslyActiveCurrentlyWaived/VEBPreviouslyActiveCurrentlyWaivedForYOEReport";
import BulkUploadLocationNumber from "./components/pages/memberInfoUpdate/bulkUpload/BulkUploadLocationNumber";
import CoreWeeklyPremiumChangeReport from "./components/pages/reportManagement/generalReports/premiumChangeReport/core/CoreWeeklyPremiumChangeReport";
import CoreMonthlyPremiumChangeReport from "./components/pages/reportManagement/generalReports/premiumChangeReport/core/CoreMonthlyPremiumChangeReport";
import VebWeeklyPremiumChangeReport from "./components/pages/reportManagement/generalReports/premiumChangeReport/veb/VebWeeklyPremiumChangeReport";
import VebMonthlyPremiumChangeReport from "./components/pages/reportManagement/generalReports/premiumChangeReport/veb/VebMonthlyPremiumChangeReport";
import ExplanationOfBenefitsV2 from "./components/pages/employer/members/memberDetails/claim/EOBv2/ExplanationOfBenefitsV2";
import ExplanationOfBenefitsV3 from "./components/pages/employer/members/memberDetails/claim/EOBv3/explanationOfBenefits/ExplanationOfBenefitsV3";
import ProtectedRoute from "./ProtectedRoute";
import { useContext, useEffect, useState } from "react";
import { ADMIN_PORTAL_LOGIN_REDIRECTION } from "./config/config";
import PremiumRecalculationManagement from "./components/pages/premiumRecalculation/PremiumRecalculationManagement";
import CoreReportsForm from "./components/pages/premiumRecalculation/coreDataGrid/coreReports/healthPlan/HealthPlan";
import ClinicCardPremiumRecalculationForm from "./components/pages/premiumRecalculation/coreDataGrid/coreReports/clinicCard/ClinicCardPlan";
import GLTDPremiumRecalculationForm from "./components/pages/premiumRecalculation/coreDataGrid/coreReports/gltd(class2)/GltdPlan";
import GSTDPremiumRecalculationForm from "./components/pages/premiumRecalculation/coreDataGrid/coreReports/gstd/GstdPlan";
import HealthPlanPremiumRecalculationForm from "./components/pages/premiumRecalculation/coreDataGrid/coreReports/healthPlan/HealthPlan";
import ProgressiveLabshealthPlanForm from "./components/pages/employer/members/memberDetails/enrollments/plans/ProgressiveLabsPlans/healthPlan/ProgressiveLabshealthPlanForm";
import EobDetails from "./components/pages/employer/members/memberDetails/claimV2/EobDetailsStatus/EobDetails";
import TestGrouphealthPlanForm from "./components/pages/employer/members/memberDetails/enrollments/plans/TestGroupPlans/healthPlan/TestGrouphealthPlanForm";
import PanhandleHealthPlanForm from "./components/pages/employer/members/memberDetails/enrollments/plans/panhandlePlanForm/healthPlan/PanhandleHealthPlanForm";
import PanhandleDentalPlanForm from "./components/pages/employer/members/memberDetails/enrollments/plans/panhandlePlanForm/dentalPlan/PanhandleDentalPlanForm";
import PanhandleVisionPlanForm from "./components/pages/employer/members/memberDetails/enrollments/plans/panhandlePlanForm/visionPlan/PanhandleVisionPlanForm";
import CoreActionTakenOrNotTakenReport from "./components/pages/reportManagement/yearlyOpenEnrollmentsReports/core/CoreActionTakenOrNotTakenReport";
import VEBActionTakenOrNotTakenReport from "./components/pages/reportManagement/yearlyOpenEnrollmentsReports/VEB/VEBActionTakenOrNotTakenReport";
import VEBEmploymentTerminatedReport from "./components/pages/reportManagement/generalReports/vebEmoloymentTerminatedReport/VEBEmploymentTerminatedReport";
import WLTCompareInfoReport from "./components/pages/reportManagement/generalReports/wltCompareReport/WLTCompareInfoReport";
import DynamicReportForm from "./components/pages/reportManagement/DynamicReportForm";
import CreateVEBPlanV2 from "./components/pages/employer/plan/createPlan/veb/CreateVEBPlanV2";
import UpdateVEBPlan from "./components/pages/employer/plan/createPlan/veb/UpdateVEBPlan";
import PreviewGroup from "./components/pages/admin/groups/preview/PreviewGroup";

const App = () => {
	// const { user } = useContext(AuthContext);

	const [loginState, setLoginStateJwt] = useState(false);

	const jwt_removed = () => {
		if (localStorage.getItem("@jwt")) {
			setLoginStateJwt(true);
		} else {
			setLoginState(false);
			// window.location.href = ADMIN_PORTAL_LOGIN_REDIRECTION;
		}
	};

	// console.log("login state", loginState);
	const setLoginState = (val: any) => {
		setLoginStateJwt(val);
	};

	useEffect(() => {
		if (localStorage.getItem("@jwt")) {
			setLoginStateJwt(true);
		} else {
			setLoginState(false);
			// window.location.href = ADMIN_PORTAL_LOGIN_REDIRECTION;
		}
	}, []);
	return (
		<div className="App">
			<Helmet>
				<title>Nexcaliber Portal</title>
			</Helmet>
			<BrowserRouter>
				<AuthContextProvider>
					<UIContextProvider>
						<GroupContextProvider>
							{/* {loginState && <AutoLogout jwt_removed={jwt_removed} />} */}
							<Routes>
								{/* ========================== AUTH_V1 ============================== */}
								{/* <Route path="/login" element={<Login />} />
								<Route path="/sign-up" element={<SignUp />} />
								<Route path="/forget-user-name" element={<ForgotUsername />} />
								<Route path="/forget-password" element={<GeneratePasswordLink />} />
								<Route path="/forget-password/verify-token/:token" element={<ResetPasswordLink />} /> */}

								{/* ========================== AUTH_V2 ============================== */}
								<Route path="/login" element={<LoginV2 setLoginState={setLoginState} />} />
								<Route path="/sign-up" element={<SignUpV2 />} />
								<Route path="/forget-user-name" element={<ForgotUsernameV2 />} />
								<Route path="/forget-password" element={<GeneratePasswordLinkV2 />} />
								<Route path="/forget-password/verify-token/:token" element={<ResetPasswordV2 />} />
								{/* {user ? ( */}
								{/* <Route element={<ProtectedRoute />}> */}
								{loginState && (
									<>
										<Route element={<AdminSidebar />}>
											<Route path="/check-date" element={<CheckDate />} />
											<Route path="/all-notifications" element={<AllNotifications />} />
											<Route path="/my-profile" element={<MyProfile />} />
											<Route path="/summary" element={<Summary />} />
											<Route path="/groups" element={<GroupHome />} />
											<Route path="/groups" element={<GroupManagement />} />
											<Route path="/create-group" element={<GroupForm />} />
											<Route path="/view-group" element={<PreviewGroup />} />
											<Route
												path="/create-group/group-page-design"
												element={<EmployeePageDesign />}
											/>
											<Route path="/members" element={<Members />} />
											<Route path="/ksop-form" element={<KsopForm />} />
											<Route path="/create-user" element={<CreateGroupOwner />} />
											<Route path="/settings/user-management" element={<UserManagement />} />
											<Route path="/settings/user" element={<UserInformation />} />
											<Route
												path="/settings/user/edit-user"
												element={<EditUserProfileInformation />}
											/>
											<Route path="/settings/user/assign-groups" element={<AssignGroups />} />
											<Route
												path="/settings/alert-subscription"
												element={<AlertSubscriptionManagement />}
											/>
											<Route
												path="/settings/portal-customization"
												element={<PortalCustomization />}
											/>
											<Route path="/settings/blogs" element={<HealthLinks />} />
											<Route path="/settings/blog/edit" element={<EditHealthLink />} />
											<Route
												path="/settings/blog/assign-groups"
												element={<HealthLinksAssignGroups />}
											/>
											<Route path="/settings/announcements" element={<Announcements />} />
											<Route path="/settings/health-card-assets" element={<AssetLibrary />} />
											<Route path="/settings/documents" element={<DocumentSharing />} />
											<Route path="/settings/announcement/edit" element={<EditAnnouncement />} />
											{/* <Route path="/employer/plan/gli-form" element={<GLIForm />} /> */}
											<Route path="/employer/plan/gli-form" element={<GLIFormV2 />} />
											<Route
												path="/settings/announcement/assign-groups"
												element={<AnnouncementAssignGroups />}
											/>
											{/* <Route path="/" element={<UserManagement />} /> */}
											{/* <Route path="/" element={<DashBoard />} /> */}
											{/* NOTE:--This should be / route and for the dashboard thing but for now i am doing GroupHome */}
											<Route path="/" element={<GroupHome />} />
											{/* <Route path="/" element={<GroupManagement />} /> */}
											{/* Group Owner Reports */}
											<Route path="/reports" element={<ReportManagement />} />
											<Route path="/reports/generate" element={<DynamicReportForm />} />
											<Route path="/bulk-text" element={<BulkText />} />
											<Route path="/veb-data-export" element={<VebDataExport />} />
											<Route path="/report/census" element={<CensusReport />} />
											<Route
												path="/report/veb-employment-terminated-report"
												element={<VEBEmploymentTerminatedReport />}
											/>
											<Route
												path="/report/location-employee"
												element={<LocationEmployeeReport />}
											/>
											<Route path="/report/dependent" element={<DependentReport />} />
											<Route path="/report/total-deduction" element={<TotalDeductionReport />} />
											<Route path="/report/plan-deduction" element={<PlanDeductionReport />} />
											<Route path="/report/veb-deduction" element={<VEBDeductionReport />} />
											<Route path="/report/benefit-changes" element={<BenefitChangesReport />} />
											<Route
												path="/report/open-enrollment-changes"
												element={<OpenEnrollmentChangesReport />}
											/>
											<Route
												path="/report/employee-info-changes"
												element={<EmployeeInfoChangesReport />}
											/>
											<Route path="/report/personal-change" element={<PersonalChangeReport />} />
											<Route
												path="/report/employee-termination"
												element={<EmployeeTerminationReport />}
											/>
											<Route path="/report/wlt-compare" element={<WLTCompareReport />} />
											<Route path="/report/wlt-info-compare" element={<WLTCompareInfoReport />} />
											<Route
												path="/report/veb-waived-benefits"
												element={<VEBWaivedBenefitsReport />}
											/>
											<Route
												path="/report/active-plan-for-employee"
												element={<ActivePlanForEmployeeReport />}
											/>
											<Route path="/report/remittance" element={<RemittanceReport />} />
											<Route path="/report/active-paycheck" element={<ActivePaycheckReport />} />
											<Route
												path="/report/active-health-plan-and-clinic-card-for-member"
												element={<ActiveHealthPlanAndClinicCardMemberReport />}
											/>
											<Route path="/report/veb-billing" element={<VEBBillingReport />} />

											<Route
												path="/report/active-core-enrollment-for-yoe"
												element={<CoreActiveEnrollmentsForYOEReport />}
											/>
											<Route
												path="/report/active-veb-enrollment-for-yoe"
												element={<VEBActiveEnrollmentsForYOEReport />}
											/>
											<Route
												path="/report/core-previously-active-currently-waived"
												element={<CorePreviouslyActiveCurrentlyWaivedForYOEReport />}
											/>
											<Route
												path="/report/veb-previously-active-currently-waived"
												element={<VEBPreviouslyActiveCurrentlyWaivedForYOEReport />}
											/>
											<Route
												path="/report/core-weekly-premium-change-report"
												element={<CoreWeeklyPremiumChangeReport />}
											/>
											<Route
												path="/report/core-monthly-premium-change-report"
												element={<CoreMonthlyPremiumChangeReport />}
											/>
											<Route
												path="/report/core-action-taken-or-not-taken"
												element={<CoreActionTakenOrNotTakenReport />}
											/>
											<Route
												path="/report/veb-weekly-premium-change-report"
												element={<VebWeeklyPremiumChangeReport />}
											/>
											<Route
												path="/report/veb-monthly-premium-change-report"
												element={<VebMonthlyPremiumChangeReport />}
											/>
											<Route
												path="/report/veb-action-taken-or-not-taken"
												element={<VEBActionTakenOrNotTakenReport />}
											/>
											{/* Enroller Reports */}
											{/* <Route path="/enroller-reports" element={<EnrollerReportManagement />} /> */}
											<Route path="/enroller-report/agent-details" element={<EnrollerReport />} />
											<Route
												path="/enroller-report/particular-agents"
												element={<AgentReport />}
											/>
											<Route
												path="/enroller-report/core-particular-agents"
												element={<CoreAgentReport />}
											/>
											<Route
												path="/enroller-report/core-agent-details"
												element={<CoreEnrollerReport />}
											/>
											{/* Data Integrity Reports */}
											<Route
												path="/data-integrity-report/empty-benefit-amount"
												element={<EmptyBenefitAmountReport />}
											/>
											<Route
												path="/data-integrity-report/empty-rider-benefit-amount"
												element={<EmptyRiderBenefitAmountReport />}
											/>
											<Route
												path="/data-integrity-report/invalid-sub-plan"
												element={<InvalidSubPlanReport />}
											/>
											<Route
												path="/data-integrity-report/invalid-member-ssn-from-veb-enrollment"
												element={<InvalidMemberSSNFromVEBEnrollmentReport />}
											/>
											<Route
												path="/data-integrity-report/invalid-state-for-member"
												element={<InvalidStateForMemberReport />}
											/>
											<Route
												path="/data-integrity-report/invalid-zip-for-member"
												element={<InvalidZIPForMemberReport />}
											/>
											<Route
												path="/data-integrity-report/not-exist-member-location"
												element={<NotExistMemberLocationReport />}
											/>
											<Route
												path="/data-integrity-report/active-group-plan-null-effective-date"
												element={<ActiveGroupPlanNullEffectiveDateReport />}
											/>
											<Route
												path="/data-integrity-report/active-paycheck-less-than-one"
												element={<ActivePaycheckLessThanOneReport />}
											/>
											<Route
												path="/data-integrity-report/dependent-more-than-26-years"
												element={<DependentMoreThanEqualTo26Report />}
											/>
										</Route>
										<Route element={<EmployerSidebar />}>
											<Route path="/employer/providers" element={<Providers />} />
											<Route
												path="/employer/provider-details"
												element={<ProvidersInformation />}
											/>
											<Route
												path="/employer/providers/add-providers"
												element={<AddProviders />}
											/>
											<Route
												path="/employer/providers/update-provider-by-tax-id"
												element={<UpdateProvidersByTaxId />}
											/>
											<Route
												path="/employer/providers/edit-providers"
												element={<EditProviders />}
											/>
											<Route
												path="/employer/providers/add-providers-bulk-upload"
												element={<AddProvidersBulk />}
											/>
											<Route
												path="/employer/provider/edit-provider"
												element={<UpdateProvidersByTaxId />}
											/>
											<Route path="/employer" element={<EmployerDashboard />} />
											<Route path="/employer/all-notifications" element={<AllNotifications />} />
											<Route path="/employer/my-profile" element={<MyProfile />} />
											<Route path="/employer/members" element={<GroupMembers />} />
											<Route
												path="/employer/members/create-employee"
												element={<CreateEmployee />}
											/>
											<Route path="/employer/members/bulk-upload" element={<BulkUpload />} />
											<Route
												path="/employer/members/bulk-upload/VEB-termination"
												element={<VEBTermination />}
											/>
											<Route path="/employer/member" element={<MemberDetails />} />
											{/* <Route path="/employer/member/health-plan" element={<HealthPlanForm />} /> */}
											<Route
												path="/employer/member/health-plan"
												element={<DynamicHealthPlanForm />}
											/>
											<Route
												path="/employer/member/christmas-club"
												element={<ChristmasClubForm />}
											/>
											<Route path="/employer/member/lincoln-form" element={<LincolnForm />} />
											<Route path="/employer/member/ksop-form" element={<KsopForm />} />
											<Route path="/employer/member/gltd-form" element={<GltdForm />} />
											<Route path="/employer/member/gstd-form" element={<GstdForm />} />
											{/* <Route path="/employer/member/gli-form" element={<GLIForm />} /> */}
											<Route path="/employer/member/gli-form" element={<GLIFormV2 />} />
											<Route path="/employer/member/helping-our-own" element={<PDForm />} />
											<Route path="/employer/member/clinic-card" element={<ClinicCardForm />} />
											<Route
												path="/employer/member/approval-plan-form"
												element={<ApprovalPlanForm />}
											/>
											<Route
												path="/employer/member/claims/eob-details"
												element={<EOBDetails />}
											/>
											{/* Intercity Plans */}
											<Route
												path="/employer/member/intercity-health-plan"
												element={<IntercityHealthPlanForm />}
											/>
											<Route
												path="/employer/member/intercity-health-plan-v2"
												element={<IntercityHealthPlanFormV2 />}
											/>
											<Route
												path="/employer/member/intercity-group-long-term-disability"
												element={<IntercityGroupLongTermDisabilityForm />}
											/>
											{/* Progressive Labs Plans */}
											<Route
												path="/employer/member/progressive-labs-health-plan"
												element={<ProgressiveLabshealthPlanForm />}
											/>
											{/* Test Group Plans */}
											<Route
												path="/employer/member/panhandle-health-plan"
												element={<PanhandleHealthPlanForm />}
											/>
											<Route
												path="/employer/member/panhandle-dental-plan"
												element={<PanhandleDentalPlanForm />}
											/>
											<Route
												path="/employer/member/panhandle-vision-plan"
												element={<PanhandleVisionPlanForm />}
											/>
											<Route
												path="/employer/member/test-group-health-plan"
												element={<TestGrouphealthPlanForm />}
											/>
											<Route
												path="/employer/member/create-dependent"
												element={<CreateDependent />}
											/>
											<Route path="/employer/member/add-employment" element={<AddEmployment />} />
											<Route path="/employer/member/add-paycheck" element={<AddPaycheck />} />
											<Route path="/employer/plan-management" element={<PlanManagement />} />
											{/* <Route path="/employer/plan/ksop-form" element={<KsopForm />} /> */}
											{/* <Route path="/employer/plan/lincoln-form" element={<LincolnForm />} /> */}
											<Route
												path="/employer/plan/create-core-plan"
												element={<CreateCorePlan />}
											/>
											{/* <Route path="/update-veb-plan/:planId" element={<UpdateVEBPlan />} /> */}
											<Route
												path="/employer/plan/create-veb-plan"
												element={<CreateVEBPlanV2 />}
											/>
											<Route path="/employer/plan/success" element={<ExcelToJson />} />
											<Route
												path="/employer/member/edit-contact"
												element={<EditContactInformation />}
											/>
											<Route
												path="/employer/member/edit-profile"
												element={<EditProfileInformation />}
											/>

											<Route
												path="/employer/member/change-password"
												element={<MemberChangePassword />}
											/>
											<Route
												path="/employer/member/edit-member-settings"
												element={<EditMemberSettings />}
											/>
											<Route path="/employer/member/dependent" element={<DependentDetails />} />
											<Route path="/employer/create-user" element={<CreateGroupOwner />} />
											<Route
												path="/employer/member/dependent/edit-contact"
												element={<EditDependentContactInformation />}
											/>
											<Route
												path="/employer/member/dependent/edit-profile"
												element={<EditDependentProfileInformation />}
											/>
											<Route
												path="/employer/member/dependent/edit-member-settings"
												element={<EditDependentSettings />}
											/>
											<Route path="/employer/open-enrollment" element={<OpenEnrollment />} />
											<Route
												path="/employer/VEB-open-enrollment"
												element={<VEBOpenEnrollment />}
											/>
											<Route
												path="/employer/all-VEB-enrollments"
												element={<AllVEBEnrollments />}
											/>
											<Route path="/employer/all-enrollments" element={<AllEnrollments />} />
											<Route path="/employer/locations" element={<Locations />} />
											<Route path="/employer/locations/add-location" element={<AddLocation />} />
											<Route
												path="/employer/locations/edit-location"
												element={<EditLocation />}
											/>
											<Route
												path="/employer/settings/user-management"
												element={<UserManagement />}
											/>
											<Route path="/employer/settings/user" element={<UserInformation />} />
											<Route
												path="/employer/settings/user/assign-groups"
												element={<AssignGroups />}
											/>
											<Route
												path="/employer/settings/enroller-user-management"
												element={<EnrollerManagementGrid />}
											/>
											<Route path="/employer/member-portal-UI" element={<EmployeePageDesign />} />
											<Route path="/employer/health-card-config" element={<HealthCardConfig />} />
											<Route path="/employer/health-card-assets" element={<AssetLibrary />} />
											<Route
												path="/employer/settings/portal-customization"
												element={<PortalCustomization />}
											/>
											<Route
												path="/employer/settings/alert-subscription"
												element={<AlertSubscriptionManagement />}
											/>
											<Route
												path="/employer/settings/announcements"
												element={<Announcements />}
											/>
											<Route path="/employer/settings/blogs" element={<HealthLinks />} />
											<Route
												path="/employer/settings/announcement/edit"
												element={<EditAnnouncement />}
											/>
											<Route
												path="/employer/settings/announcement/assign-groups"
												element={<AnnouncementAssignGroups />}
											/>
											<Route path="/employer/settings/blog/edit" element={<EditHealthLink />} />
											<Route
												path="/employer/settings/blog/assign-groups"
												element={<HealthLinksAssignGroups />}
											/>
											<Route path="/employer/claim/EOB" element={<ExplanationOfBenefitsV3 />} />
											{/* premium recalculation */}
											<Route
												path="/employer/Premiumrecalculation"
												element={<PremiumRecalculationManagement />}
											/>
											<Route
												path="/employer/Premiumrecalculation/core/healthplan"
												element={<HealthPlanPremiumRecalculationForm />}
											/>
											<Route
												path="/employer/Premiumrecalculation/core/clinic-card"
												element={<ClinicCardPremiumRecalculationForm />}
											/>
											<Route
												path="/employer/Premiumrecalculation/core/gstd"
												element={<GSTDPremiumRecalculationForm />}
											/>
											<Route
												path="/employer/Premiumrecalculation/core/gltd-class2"
												element={<GLTDPremiumRecalculationForm />}
											/>
											{/* Employer Reports Route */}
											<Route path="/employer/reports" element={<ReportManagement />} />
											<Route path="/employer/reports/generate" element={<DynamicReportForm />} />
											<Route path="/employer/report/census" element={<CensusReport />} />
											<Route
												path="/employer/report/veb-employment-terminated-report"
												element={<VEBEmploymentTerminatedReport />}
											/>
											<Route
												path="/employer/report/location-employee"
												element={<LocationEmployeeReport />}
											/>
											<Route path="/employer/report/dependent" element={<DependentReport />} />
											<Route
												path="/employer/report/total-deduction"
												element={<TotalDeductionReport />}
											/>
											<Route
												path="/employer/report/plan-deduction"
												element={<PlanDeductionReport />}
											/>
											<Route
												path="/employer/report/veb-deduction"
												element={<VEBDeductionReport />}
											/>
											<Route
												path="/employer/report/benefit-changes"
												element={<BenefitChangesReport />}
											/>
											<Route
												path="/employer/report/open-enrollment-changes"
												element={<OpenEnrollmentChangesReport />}
											/>
											<Route
												path="/employer/report/employee-info-changes"
												element={<EmployeeInfoChangesReport />}
											/>
											<Route
												path="/employer/report/personal-change"
												element={<PersonalChangeReport />}
											/>
											<Route
												path="/employer/report/employee-termination"
												element={<EmployeeTerminationReport />}
											/>
											<Route path="/employer/report/wlt-compare" element={<WLTCompareReport />} />
											<Route
												path="/employer/report/wlt-info-compare"
												element={<WLTCompareInfoReport />}
											/>
											<Route
												path="/employer/report/veb-waived-benefits"
												element={<VEBWaivedBenefitsReport />}
											/>
											<Route
												path="/employer/report/active-plan-for-employee"
												element={<ActivePlanForEmployeeReport />}
											/>
											<Route path="/employer/report/remittance" element={<RemittanceReport />} />
											<Route
												path="/employer/report/active-paycheck"
												element={<ActivePaycheckReport />}
											/>
											<Route
												path="/employer/report/active-health-plan-and-clinic-card-for-member"
												element={<ActiveHealthPlanAndClinicCardMemberReport />}
											/>
											<Route path="/employer/report/veb-billing" element={<VEBBillingReport />} />

											<Route
												path="/employer/report/active-core-enrollment-for-yoe"
												element={<CoreActiveEnrollmentsForYOEReport />}
											/>
											<Route
												path="/employer/report/active-veb-enrollment-for-yoe"
												element={<VEBActiveEnrollmentsForYOEReport />}
											/>
											<Route
												path="/employer/report/core-previously-active-currently-waived"
												element={<CorePreviouslyActiveCurrentlyWaivedForYOEReport />}
											/>
											<Route
												path="/employer/report/veb-previously-active-currently-waived"
												element={<VEBPreviouslyActiveCurrentlyWaivedForYOEReport />}
											/>
											<Route
												path="/employer/report/core-weekly-premium-change-report"
												element={<CoreWeeklyPremiumChangeReport />}
											/>
											<Route
												path="/employer/report/core-monthly-premium-change-report"
												element={<CoreMonthlyPremiumChangeReport />}
											/>
											<Route
												path="/employer/report/core-action-taken-or-not-taken"
												element={<CoreActionTakenOrNotTakenReport />}
											/>
											<Route
												path="/employer/report/veb-weekly-premium-change-report"
												element={<VebWeeklyPremiumChangeReport />}
											/>
											<Route
												path="/employer/report/veb-monthly-premium-change-report"
												element={<VebMonthlyPremiumChangeReport />}
											/>
											<Route
												path="/employer/report/veb-action-taken-or-not-taken"
												element={<VEBActionTakenOrNotTakenReport />}
											/>
											{/* Enroller Reports */}
											<Route
												path="/employer/enroller-reports"
												element={<EnrollerReportManagement />}
											/>
											<Route
												path="/employer/enroller-report/agent-details"
												element={<EnrollerReport />}
											/>
											<Route
												path="/employer/enroller-report/particular-agents"
												element={<AgentReport />}
											/>
											<Route
												path="/employer/enroller-report/core-particular-agents"
												element={<CoreAgentReport />}
											/>
											<Route
												path="/employer/enroller-report/core-agent-details"
												element={<CoreEnrollerReport />}
											/>
											{/* Data Integrity Reports */}
											<Route
												path="/employer/data-integrity-report/empty-benefit-amount"
												element={<EmptyBenefitAmountReport />}
											/>
											<Route
												path="/employer/data-integrity-report/empty-rider-benefit-amount"
												element={<EmptyRiderBenefitAmountReport />}
											/>
											<Route
												path="/employer/data-integrity-report/invalid-sub-plan"
												element={<InvalidSubPlanReport />}
											/>
											<Route
												path="/employer/data-integrity-report/invalid-member-ssn-from-veb-enrollment"
												element={<InvalidMemberSSNFromVEBEnrollmentReport />}
											/>
											<Route
												path="/employer/data-integrity-report/invalid-state-for-member"
												element={<InvalidStateForMemberReport />}
											/>
											<Route
												path="/employer/data-integrity-report/invalid-zip-for-member"
												element={<InvalidZIPForMemberReport />}
											/>
											<Route
												path="/employer/data-integrity-report/not-exist-member-location"
												element={<NotExistMemberLocationReport />}
											/>
											<Route
												path="/employer/data-integrity-report/active-group-plan-null-effective-date"
												element={<ActiveGroupPlanNullEffectiveDateReport />}
											/>
											<Route
												path="/employer/data-integrity-report/active-paycheck-less-than-one"
												element={<ActivePaycheckLessThanOneReport />}
											/>
											<Route
												path="/employer/data-integrity-report/dependent-more-than-26-years"
												element={<DependentMoreThanEqualTo26Report />}
											/>
											{/* Member Info Update */}
											<Route
												path="/employer/member-info-updates"
												element={<MemberInfoUpdate />}
											/>
											<Route
												path="/employer/member-info-update/email"
												element={<EmailUpdation />}
											/>
											<Route path="/employer/member-info-update/SSN" element={<SSNUpdation />} />
											<Route
												path="/employer/member-info-update/location-number"
												element={<LocationNumberUpdation />}
											/>
											<Route
												path="/employer/member-info-update/buy-up-eligibility"
												element={<BuyUpEligibilityUpdation />}
											/>
											<Route
												path="/employer/member-info-update/hire-date"
												element={<HireDateUpdate />}
											/>
											<Route
												path="/employer/member-info-update/date-of-birth"
												element={<DateOfBirthUpdate />}
											/>
											<Route
												path="/employer/member-info-update/bulk-upload-location-number"
												element={<BulkUploadLocationNumber />}
											/>
										</Route>
										<Route path="/employer" element={<EmployerSidebar />}>
											<Route path="claim/EOB/*" element={<ExplanationOfBenefitsV2 />} />
										</Route>
										<Route path="/claim-status/EOB" element={<EobDetails />} />
									</>
								)}
								{/* ) : (
									// </Route>
									<Navigate to="/login" replace />
								)} */}
								<Route element={<ProtectedRoute />}>
									<Route path="*" element={<LoginV2 setLoginState={setLoginState} />} />
								</Route>
							</Routes>
						</GroupContextProvider>
					</UIContextProvider>
				</AuthContextProvider>
			</BrowserRouter>
		</div>
	);
};

export default App;
